import __axios from "axios";
import { axiosV2 } from "config/@axios";
import idFixer, { toId } from "utils/idFixer";

export const FETCH_CONVERSATION = "conversationActions::fetchConversation";
export const FETCH_CONVERSATION_SUCCESS =
  "conversationActions::fetchConversationSuccess";
export const FETCH_CONVERSATION_FAILED =
  "conversationActions::fetchConversationFailed";

export const FETCH_SUB_CONVERSATIONS =
  "conversationActions::fetchSubConversations";
export const FETCH_SUB_CONVERSATIONS_SUCCESS =
  "conversationActions::fetchSubConversationsSuccess";
export const FETCH_SUB_CONVERSATIONS_FAILED =
  "conversationActions::fetchSubConversationsFailed";
export const FETCH_SUB_CONVERSATIONS_MESSAGE =
  "conversationActions::fetchSubConversationsMessage";
export const FETCH_SUB_CONVERSATIONS_MESSAGE_SUCCESS =
  "conversationActions::fetchSubConversationsMessageSuccess";
export const FETCH_SUB_CONVERSATIONS_MESSAGE_FAILED =
  "conversationActions::fetchSubConversationsMessageFailed";
export const REMOVE_MESSAGE_FROM_CONVERSATION =
  "conversationActions::removeDraftMessageFromConversation";
export const ADD_NTIMES = "conversationActions::addNtimes";

const CancelToken = __axios.CancelToken;

const cancellers = new Map();

const createCancelToken = key => {
  cancellers.get(key)?.();

  let own;
  const token = new CancelToken(cancel => {
    own = cancel;
    cancellers.set(key, cancel);
  });

  const release = () => {
    if (cancellers.get(key) === own) {
      cancellers.delete(key);
    }
  };

  return { token, release };
};

const CONVERSATION_SCOPE = "conversation";
const subConversationsScope = id => `subConversations::${id}`;
const subConversationMessageScope = id => `subConversationMessage::${id}`;

export const fetchConversation =
  ({ folder, id }) =>
  dispatch => {
    id = toId(id);
    const { token, release } = createCancelToken(CONVERSATION_SCOPE);

    dispatch({
      type: FETCH_CONVERSATION,
      payload: {
        id,
        silent: false
      }
    });

    return axiosV2
      .get(`/conversations/${id}`, {
        cancelToken: token
      })
      .then(response => {
        let conversations = response.data.messages;
        conversations[0] = {
          ...conversations[0],
          ...response.data?.entry_message,
          parts:
            response.data?.entry_message?.attachments?.filter(
              item => item.disposition !== "inline"
            ) || []
        };
        dispatch({
          type: FETCH_CONVERSATION_SUCCESS,
          payload: {
            folder,
            id,
            conversations
          }
        });
        return response.data;
      })
      .catch(err => {
        if (__axios.isCancel(err)) {
          return;
        }

        dispatch({
          type: FETCH_CONVERSATION_FAILED,
          payload: {
            id,
            errorText: err.errorMessage
          }
        });
      })
      .finally(release);
  };

export const fetchSubConversations =
  ({ folder, id, conversationId, silent = false }) =>
  dispatch => {
    id = toId(id);
    const { token, release } = createCancelToken(subConversationsScope(id));

    dispatch({
      type: FETCH_SUB_CONVERSATIONS,
      payload: {
        id,
        silent
      }
    });

    return axiosV2
      .get(`/conversations/${conversationId}`, {
        cancelToken: token
      })
      .then(response => {
        dispatch({
          type: FETCH_SUB_CONVERSATIONS_SUCCESS,
          payload: {
            folder,
            id,
            children: response.data.messages
          }
        });
      })
      .catch(err => {
        if (__axios.isCancel(err)) {
          return;
        }

        dispatch({
          type: FETCH_SUB_CONVERSATIONS_FAILED,
          payload: {
            id,
            errorText: err.errorMessage
          }
        });
      })
      .finally(release);
  };

export const fetchSubConversationMessage =
  ({ id, silent = false }) =>
  dispatch => {
    id = idFixer(id);
    const { token, release } = createCancelToken(
      subConversationMessageScope(id)
    );

    dispatch({
      type: FETCH_SUB_CONVERSATIONS_MESSAGE,
      payload: {
        id,
        silent
      }
    });

    return axiosV2
      .get(`/messages/${id}`, {
        cancelToken: token
      })
      .then(response => {
        dispatch({
          type: FETCH_SUB_CONVERSATIONS_MESSAGE_SUCCESS,
          payload: {
            id,
            data: {
              ...response.data,
              parts:
                response.data?.attachments?.filter(
                  item => item.disposition !== "inline"
                ) || []
            }
          }
        });
      })
      .catch(err => {
        if (__axios.isCancel(err)) {
          return;
        }

        dispatch({
          type: FETCH_SUB_CONVERSATIONS_MESSAGE_FAILED,
          payload: {
            id,
            errorText: err.errorMessage
          }
        });
      })
      .finally(release);
  };

export const removeDraftMessageFromConversation = id => {
  return {
    type: REMOVE_MESSAGE_FROM_CONVERSATION,
    payload: id
  };
};

export const addNtimes = (messageId, conversationId) => {
  return {
    type: ADD_NTIMES,
    payload: {
      messageId,
      conversationId
    }
  };
};
